import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=6b1b4bba&scoped=true&"
import script from "./PurchaseList.vue?vue&type=script&lang=js&"
export * from "./PurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=6b1b4bba&lang=scss&scoped=true&"
import style1 from "./PurchaseList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PurchaseList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b4bba",
  null
  
)

export default component.exports